import React from 'react';
import { AuthWrapper } from '@/features/core/auth/screens/AuthWrapper';

export const PoliticsContainer: React.FC = () => (
  <AuthWrapper isHomepage={false}>
    <div className="w-full bg-white font-dmsans min-h-[70vh]">
      <div className="container mx-auto px-4 pt-10 pb-20 max-w-5xl">
        {/* Header */}
        <div className="mb-12 border-b border-gray-100 pb-6">
          <span className="text-sm font-semibold tracking-wider text-primary-500 uppercase">
            Termos e Transparência
          </span>
          <h1 className="text-primary-500 text-3xl md:text-4xl font-bold mt-1">
            Políticas & Privacidade
          </h1>
        </div>

        <div className="space-y-12">
          {/* Seção 1: Política de Privacidade */}
          <section className="bg-white border border-gray-200 rounded-2xl p-6 md:p-8 shadow-sm">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3 border-b border-gray-100 pb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500/10 text-primary-500 flex items-center justify-center text-base font-bold">
                1
              </span>
              Política de Privacidade
            </h2>

            <div className="space-y-6 text-gray-600 text-sm md:text-base leading-relaxed">
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">1. Introdução</h3>
                <p>
                  Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e
                  protegemos suas informações pessoais quando você utiliza nossos serviços. Ao
                  acessar ou utilizar nossos serviços, você concorda com a coleta e uso das suas
                  informações de acordo com esta política.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  2. Informações que Coletamos
                </h3>
                <p className="mb-3">
                  Coletamos diferentes tipos de informações para fornecer e melhorar nossos
                  serviços:
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 bg-gray-50 p-4 rounded-xl border border-gray-100 mb-4">
                  <ul className="space-y-1.5 list-disc pl-5 text-gray-700">
                    <li>Nome completo</li>
                    <li>CPF</li>
                    <li>E-mail e Telefone</li>
                    <li>Data de nascimento</li>
                  </ul>
                  <ul className="space-y-1.5 list-disc pl-5 text-gray-700">
                    <li>Nome completo da mãe</li>
                    <li>Endereço completo (CEP, Estado, Cidade, Bairro, Rua e Número)</li>
                  </ul>
                </div>
                <p className="mb-2">Dados financeiros necessários para realizar a compra:</p>
                <ul className="list-disc pl-5 space-y-1 text-gray-700 bg-gray-50 p-4 rounded-xl border border-gray-100">
                  <li>Número do cartão, Nome impresso, Validade e CVV</li>
                  <li>CPF do proprietário do cartão</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  3. Como Usamos suas Informações
                </h3>
                <ul className="list-disc pl-5 space-y-1 text-gray-700">
                  <li>Processar suas compras de ingressos com segurança.</li>
                  <li>Comunicar sobre eventos, confirmações e atualizações importantes.</li>
                  <li>Melhorar continuamente nossos serviços e a experiência do usuário.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  4. Compartilhamento e Segurança
                </h3>
                <p className="mb-2">
                  Compartilhamos dados exclusivamente para cumprimento de obrigações legais, com
                  processadores de pagamento e prestadores de serviços sob rigoroso compromisso de
                  confidencialidade.
                </p>
                <p>
                  Tomamos medidas de segurança avançadas para proteger seus dados pessoais contra
                  acesso não autorizado.
                </p>
              </div>
            </div>
          </section>

          {/* Seção 2: Políticas da Empresa e Cancelamento */}
          <section className="bg-white border border-gray-200 rounded-2xl p-6 md:p-8 shadow-sm">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3 border-b border-gray-100 pb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500/10 text-primary-500 flex items-center justify-center text-base font-bold">
                2
              </span>
              Políticas da Empresa & Cancelamento
            </h2>

            <div className="space-y-6 text-gray-600 text-sm md:text-base leading-relaxed">
              <div className="bg-blue-50/50 border border-blue-100 rounded-xl p-5">
                <h3 className="text-lg font-bold text-primary-500 mb-2">
                  Responsabilidade do Evento
                </h3>
                <p className="text-gray-700">
                  O produtor do evento é o único responsável pela realização, cancelamento ou
                  adiamento do evento, bem como pela restituição do valor de face do ingresso. Em
                  caso de alteração de data/horário ou cancelamento, o cliente tem direito à
                  solicitação do reembolso do ingresso.
                </p>
              </div>

              {/* Destaque CDC Art. 49 */}
              <div className="bg-emerald-50/60 border border-emerald-200 rounded-xl p-5">
                <div className="flex items-center gap-2 text-emerald-800 font-bold mb-2">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Direito de Arrependimento — Artigo 49 do CDC
                </div>
                <p className="text-gray-700">
                  Garantimos o direito ao cancelamento do pedido dentro do prazo de{' '}
                  <strong>7 (sete) dias</strong> a contar da data de compra. Para eventos que
                  ocorram em menos de 7 dias da compra, a solicitação pode ser feita com até{' '}
                  <strong>48 horas de antecedência</strong> à realização do evento.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Prazos de Reembolso</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 border border-gray-200 p-4 rounded-xl">
                    <span className="font-bold text-gray-900 block mb-1">Cartão de Crédito</span>
                    <p className="text-xs text-gray-600">
                      Estorno efetuado entre 30 a 40 dias após a confirmação. Creditado na fatura
                      atual ou subsequente do banco emissor.
                    </p>
                  </div>
                  <div className="bg-gray-50 border border-gray-200 p-4 rounded-xl">
                    <span className="font-bold text-gray-900 block mb-1">Pagamento via PIX</span>
                    <p className="text-xs text-gray-600">
                      Reembolso creditado diretamente na mesma conta bancária utilizada em 20 a 30
                      dias após confirmação.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Seção 3: Transferência de Ingressos */}
          <section className="bg-white border border-gray-200 rounded-2xl p-6 md:p-8 shadow-sm">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3 border-b border-gray-100 pb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500/10 text-primary-500 flex items-center justify-center text-base font-bold">
                3
              </span>
              Transferência de Ingressos
            </h2>

            <div className="space-y-4 text-gray-600 text-sm md:text-base leading-relaxed">
              <ul className="space-y-2 list-disc pl-5 text-gray-700">
                <li>O destinatário deve possuir uma conta validada na Banca do Ingresso.</li>
                <li>
                  Transferências podem ser realizadas até <strong>3 horas antes</strong> do início
                  do evento.
                </li>
                <li>Cada ingresso só pode ser transferido uma única vez.</li>
                <li>
                  Após a transferência efetuada, o processo não pode ser cancelado ou revertido.
                </li>
              </ul>
            </div>
          </section>

          {/* Seção 4: Contato e Suporte */}
          <div className="bg-gray-900 text-white rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6 shadow-md">
            <div>
              <h3 className="text-xl font-bold mb-2">
                Ficou com alguma dúvida sobre nossas políticas?
              </h3>
              <p className="text-gray-400 text-sm max-w-xl">
                Nossa equipe de suporte está à disposição 24 horas por dia para atender sua
                solicitação.
              </p>
            </div>
            <a
              href="https://suporte.bancadoingresso.com.br/open"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-bold px-6 py-3.5 rounded-xl transition-all whitespace-nowrap"
            >
              Falar com o Suporte
            </a>
          </div>
        </div>
      </div>
    </div>
  </AuthWrapper>
);
